
/**
 * ============================================================
 * AM DIAGNOSTICS | VIDEO CLICK-TO-LOAD
 * Version: 1.1
 * ============================================================
 *
 * PURPOSE:
 * Loads laboratory test videos only when the visitor clicks
 * the "Watch Test" button.
 *
 * FEATURES:
 * - No video files downloaded before clicking.
 * - Compatible with Shopify CDN WebM files.
 * - Works with expandable competitor video sections.
 * - Native video controls: Play, Pause, Volume, Fullscreen.
 * - Does not modify charts, tables or result cards.
 *
 * REQUIRED HTML:
 * <main class="amx">
 *   <button
 *     type="button"
 *     class="play"
 *     data-webm="https://cdn.shopify.com/...webm">
 *     ▶ Watch Test
 *   </button>
 * </main>
 *
 * ============================================================
 */

(function () {
  "use strict";

  // ----------------------------------------------------------
  // 1. PREVENT DUPLICATE SCRIPT INITIALISATION
  // ----------------------------------------------------------

  if (window.__amDiagnosticsVideoLoaderInstalled) {
    return;
  }

  window.__amDiagnosticsVideoLoaderInstalled = true;


  // ----------------------------------------------------------
  // 2. LISTEN FOR CLICKS ON VIDEO BUTTONS
  // ----------------------------------------------------------

  document.addEventListener("click", function (event) {

    // Only react to video buttons inside AM Diagnostics.
    var button = event.target.closest(
      ".amx button[data-webm]"
    );

    if (!button || button.disabled) {
      return;
    }


    // --------------------------------------------------------
    // 3. GET THE VIDEO URL
    // --------------------------------------------------------

    var url = (
      button.getAttribute("data-webm") || ""
    ).trim();


    // --------------------------------------------------------
    // 4. VALIDATE THE VIDEO URL
    // --------------------------------------------------------

    // Only accept HTTPS links ending in .webm,
    // with an optional query string.

    if (!/^https:\/\/[^\s]+\.webm(?:\?[^\s]*)?$/i.test(url)) {

      button.setAttribute(
        "title",
        "Add a valid HTTPS .webm URL in data-webm."
      );

      button.textContent = "Video URL not configured";
      button.disabled = true;

      return;
    }


    // --------------------------------------------------------
    // 5. CREATE THE HTML5 VIDEO PLAYER
    // --------------------------------------------------------

    var player = document.createElement("video");

    // Native playback controls.
    player.controls = true;

    // Play inline on mobile devices.
    player.playsInline = true;

    // Load video metadata only after clicking.
    player.preload = "metadata";

    player.setAttribute("playsinline", "");

    // Accessibility.
    player.setAttribute(
      "aria-label",
      button.getAttribute("aria-label") ||
      "Laboratory test video"
    );


    // --------------------------------------------------------
    // 6. VIDEO PLAYER STYLING
    // --------------------------------------------------------

    player.style.display = "block";
    player.style.width = "100%";
    player.style.height = "auto";
    player.style.aspectRatio = "16 / 9";
    player.style.backgroundColor = "#101114";
    player.style.borderRadius = "12px";


    // --------------------------------------------------------
    // 7. ADD THE WEBM VIDEO SOURCE
    // --------------------------------------------------------

    var source = document.createElement("source");

    source.src = url;
    source.type = "video/webm";

    player.appendChild(source);


    // --------------------------------------------------------
    // 8. HANDLE VIDEO LOADING ERRORS
    // --------------------------------------------------------

    player.addEventListener("error", function () {

      if (player.parentElement) {

        var message = document.createElement("p");

        message.setAttribute("role", "alert");

        message.textContent =
          "This video could not be loaded. Please check the WebM link.";

        player.insertAdjacentElement(
          "afterend",
          message
        );
      }

    });


    // --------------------------------------------------------
    // 9. REPLACE THE BUTTON WITH THE VIDEO PLAYER
    // --------------------------------------------------------

    button.replaceWith(player);

    // Start loading the selected video.
    player.load();


    // --------------------------------------------------------
    // 10. START PLAYBACK
    // --------------------------------------------------------

    var playRequest = player.play();

    if (
      playRequest &&
      typeof playRequest.catch === "function"
    ) {

      playRequest.catch(function () {

        // If autoplay after interaction is blocked,
        // the native Play button remains available.

      });

    }

  });

})();
